export const BasePaths = {
  PATIENT: "/patient",
  DOCTOR: "/consultant",
};

export const AuthPaths = {
  SIGNIN: "/signin",
  DOCTOR_SIGNIN: "/signin-doctor",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
};

export const PatientPaths = {
  PATIENT_FEED: "/patient/feeds",
  PATIENT_APPOINTMENT: "/patient/appointments",
  PATIENT_GROUPS: "/patient/groups",
  PATIENT_MESSAGES: "/patient/messages",
  PATIENT_JOURNAL: "/patient/my-journal",
};

export const ConsultantPaths = {
  CONSULTANT_FEED: "/consultant/feeds",
  CONSULTANT_APPOINTMENT: "/consultant/appointments",
  CONSULTANT_GROUPS: "/consultant/groups",
  CONSULTANT_MESSAGES: "/consultant/messages",
  CONSULTANT_JOURNAL: "/consultant/my-journal",
};
